import { useState } from "react"
import { axiosInstance } from "../helpers"

export const useStripeCheckout = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [clientSecret, setClientSecret] = useState<string | null>(null)

    const createPaymentIntent = async (leaseId: number, billIds: number[]) => {
        setIsLoading(true)
        const response = await axiosInstance.post('/rent/stripe-tenants/create-checkout-session/', {
            lease_id: leaseId,
            bill_ids: billIds,
        })
        console.log(response)

        setClientSecret(response.data.session.client_secret)
        setIsLoading(false)
        return response.data.session.client_secret
    }

    return {
        clientSecret,
        createPaymentIntent,
        isLoading,
    }
}